module.exports = __webpack_public_path__ + "static/media/cold_info.23fe34ab.svg";